import { DPD_TIMEOUT_EDIT, DPD_TIMEOUT_LOAD, DPD_TIMEOUT_UNLOAD } from "../constants/actionTypes";

const defaultState = {
  data: [],
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case DPD_TIMEOUT_LOAD: {
      const list = Array.isArray(action?.payload) ? action.payload : [];
      return { ...state, data: list };
    }
    case DPD_TIMEOUT_EDIT: {
      const { service, field, value } = action.payload || {};
      if (!service || !field) return state;
      return {
        ...state,
        data: state.data.map((item) =>
          item.service === service ? { ...item, [field]: value } : item
        ),
      };
    }
    case DPD_TIMEOUT_UNLOAD:
      return defaultState;
    default:
      return state;
  }
};
